import React from "react";
import { Route, Switch } from "react-router-dom";

import RestPassword from "./Auth/restPassword";

import AdminDashboard from "./Admin";
import DailyLivingActivities from "./Admin/Questionnaire/dailyLivingActivities";
import HealthCondition from "./Admin/Questionnaire/healthCondition";
import DailyBaseLine from "./Admin/Questionnaire/dailyBaseLine";
import RedFlags from "./Admin/Questionnaire/redFlags";
import Users from "./Admin/Users";
import Reports from "./Admin/Reports";
import Settings from "./Admin/Settings";
import CorporateAccount from "./Admin/CorporateAccount";
import AccountManager from "./Admin/CorporateAccount/components/AccountManager";
import CareRecipientAccounts from "./Admin/CorporateAccount/components/CareRecipientAccounts";

import ClientDashboard from "./Client";
import CarePlan from "./Client/CarePlan";
import DailyUpdate from "./Client/DailyUpdate";
import ClientReports from "./Client/Reports";
import PatientBaseLine from "./Client/PatientBaseline";
import CustomerSettings from "./Client/Settings";
import Inventory from "./Admin/Inventory";

const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      {/* <Route path={`${match.url}home`} component={Home}/> */}

      <Route
        exact
        path={`${match.url}admin/dashboard`}
        component={AdminDashboard}
      />
      <Route path={`${match.url}resetPassword`} component={RestPassword} />
      <Route
        path={`${match.url}admin/resetPassword`}
        component={RestPassword}
      />

      <Route
        exact
        path={`${match.url}client/dashboard`}
        component={ClientDashboard}
      />
      <Route exact path={`${match.url}client/carePlan`} component={CarePlan} />
      <Route
        exact
        path={`${match.url}client/dailyUpdate`}
        component={DailyUpdate}
      />
      <Route
        exact
        path={`${match.url}client/reports`}
        component={ClientReports}
      />
      <Route
        exact
        path={`${match.url}client/patientBaseline`}
        component={PatientBaseLine}
      />
      <Route
        exact
        path={`${match.url}client/settings`}
        component={CustomerSettings}
      />

      <Route
        exact
        path={`${match.url}dailyLivingActivities`}
        component={DailyLivingActivities}
      />
      <Route
        exact
        path={`${match.url}healthCondition`}
        component={HealthCondition}
      />
      <Route
        exact
        path={`${match.url}dailyBaseLine`}
        component={DailyBaseLine}
      />
      <Route exact path={`${match.url}redFlags`} component={RedFlags} />
      <Route exact path={`${match.url}users`} component={Users} />
      <Route
        exact
        path={`${match.url}corporateAccounts`}
        component={CorporateAccount}
      />
      <Route
        exact
        path={`${match.url}accountManager`}
        component={AccountManager}
      />
      <Route
        exact
        path={`${match.url}careRecipientAccounts`}
        component={CareRecipientAccounts}
      />
      <Route exact path={`${match.url}reports`} component={Reports} />
      <Route exact path={`${match.url}settings`} component={Settings} />
      <Route exact path={`${match.url}admin/inventory`} component={Inventory} />
    </Switch>
  </div>
);

export default App;
